import UpdatePlantingCycleWrapper from './UpdatePlantingCycleWrapper';

export default UpdatePlantingCycleWrapper;
